import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Col, Row, Label, Grid, Button } from 'react-bootstrap';

import { DashboardMap } from './DashboardMap';
import { AddOnsDataManagerCommand } from '../../addOns/commands/AddOnsCommand';
import { PathAPI } from '../../../api/datamanager/PathAPI';
import { LineAPI } from '../../../api/datamanager/LineAPI';
import { StopAPI } from '../../../api/datamanager/StopAPI';
import { TripAPI } from '../../../api/datamanager/TripAPI';
import { PathStopAPI } from '../../../api/datamanager/PathStopAPI';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { TitleRow } from '../../TitleRow';
import { EditionSelector } from '../../EditionSelector';

export class Dashboard extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            networkStops: [],
            networkPaths: [],

            networkMapStops: [],
            networkMapPaths: [],

            networkStopsCount: 0,
            networkPathsCount: 0,
            networkLinesCount: 0,
            networkTripsCount: 0,

            loadingNetworkLines: true,
            loadingNetworkStops: true,
            loadingNetworkPaths: true,
            loadingNetworkTrips: true,

            draftMapStops: [],
            draftMapPaths: [],
            draftPathStops: [],

            loadingDraft: true,

            alertTitle: "",
            alertMessage: "",
            icon: "",
            alertStyle: "",
            showErrorModal: false,

            addOns: [],

            commands: {
                addOns: new AddOnsDataManagerCommand()
            },

            actions: {
                isExecutingAddOn: false,
            },
            render: {
                addOn: "",
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);

        // Add as observer
        this.context.addEditionObserver(this);
        this.getAddOns();
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    updateNetwork() {
        this.setState({
            loadingNetworkLines: true,
            loadingNetworkPaths: true,
            loadingNetworkStops: true
        }, () => {
            let selectedProvider = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProvider = this.context.selectedProvider.split(':')[0];
            }

            this.countLines(this.context.edition, selectedProvider);
            this.getPaths(this.context.edition, selectedProvider);
            this.getStops(this.context.edition, selectedProvider);
        });
    }

    updateDraftNetwork() {
        this.setState({
            loadingDraft: true
        }, () => {
            let selectedProvider = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProvider = this.context.selectedProvider.split(':')[0];
            }

            this.getDraftPathStops(this.context.edition, selectedProvider);
        });
    }

    updatePlanning() {
        this.setState({
            loadingNetworkTrips: true
        }, () => {
            let selectedProvider = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProvider = this.context.selectedProvider.split(':')[0];
            }

            this.countTrips(this.context.edition, selectedProvider);
        });
    }

    // ----------------------

    getStops(edition, provider = '') {
        StopAPI.list(edition.network, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingNetworkStops: false,
                    networkStops: data,
                    networkStopsCount: data.length,
                }, () => {
                    this.stopConverter();
                });
            }).catch((err) => {
                this.setState({
                    loadingNetworkStops: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    countLines(edition, provider = '') {
        LineAPI.countActive(edition.network, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingNetworkLines: false,
                    networkLinesCount: undefined !== data.count ? data.count : 0
                });
            }).catch((err) => {
                this.setState({
                    loadingNetworkLines: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    getPaths(edition, provider = '') {
        PathAPI.list(edition.network, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingNetworkPaths: false,
                    networkPaths: data,
                    networkPathsCount: data.length
                }, () => {
                    this.createTrips();
                });
            }).catch((err) => {
                this.setState({
                    loadingNetworkPaths: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    countTrips(edition, provider = '') {
        TripAPI.countActive(edition.network, edition.planning, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingNetworkTrips: false,
                    networkTripsCount: undefined !== data.count ? data.count : 0
                });
            }).catch((err) => {
                this.setState({
                    loadingNetworkTrips: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    getDraftPathStops(edition, provider = '') {
        PathStopAPI.listDraft(edition.draftNetwork, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingDraft: false,
                    draftPathStops: data
                }, () => { this.createDraftMap(); });
            }).catch((err) => {
                this.setState({
                    loadingDraft: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    stopConverter = () => {
        const { networkStops, networkStopsCount } = this.state;
        const stopsM = [];

        if (0 < networkStopsCount) {
            networkStops.forEach((stop) => {
                if (undefined === stopsM.find(s => s.id === stop.id)) {
                    stopsM.push({
                        id: stop.id,
                        code: stop.code,
                        name: stop.name,
                        latitude: stop.latitude,
                        longitude: stop.longitude,
                        position: [stop.latitude, stop.longitude]
                    });
                }
            });
        }

        this.setState({
            networkMapStops: stopsM
        });
    }

    createTrips = () => {
        const { networkPaths, networkPathsCount } = this.state;

        const tripsM = [];
        const defaultLineColor = "rgba(0,0,0,1)";

        if (0 < networkPathsCount) {
            networkPaths.forEach((path) => {
                if (undefined === path.pathStops || 0 === path.pathStops.length) {
                    return;
                }

                path.pathStops.sort((a, b) => a.stopOrder - b.stopOrder);
                path.pathStops.forEach((stop, i) => {
                    if (path.pathStops[i + 1] !== undefined) {
                        tripsM.push({
                            originID: stop.stop.id,
                            origin: [stop.stop.latitude, stop.stop.longitude],
                            destination: [path.pathStops[i + 1].stop.latitude, path.pathStops[i + 1].stop.longitude],
                            destinationID: path.pathStops[i + 1].stop.id,
                            lineColor: undefined === path.line.lineColor ?
                                defaultLineColor :
                                `rgba(${path.line.lineColor.backColor.r},${path.line.lineColor.backColor.g},${path.line.lineColor.backColor.b},${path.line.lineColor.backColor.a})`
                        });
                    }
                });
            });
        }

        this.setState({
            networkMapPaths: tripsM
        });
    }

    createDraftMap = () => {
        const { draftPathStops } = this.state;
        let draftMapPaths = [];
        let draftMapStops = [];

        draftPathStops.sort(function (a, b) {
            return a.pathId - b.pathId || a.stopOrder - b.stopOrder;
        });

        let lastPathId = undefined;
        let prevPathStop = undefined;
        const defaultLineColor = "rgba(0,0,0,1)";
        draftPathStops.forEach((pathStop) => {
            if (undefined === draftMapStops.find(stop => stop.id === pathStop.stopId)) {
                draftMapStops.push({
                    code: pathStop.stopCode,
                    position: [pathStop.stopLatitude, pathStop.stopLongitude],
                    id: pathStop.stopId,
                    name: pathStop.stopName,
                    latitude: pathStop.stopLatitude,
                    longitude: pathStop.stopLongitude
                });
            }

            if (pathStop.pathId !== lastPathId) {
                lastPathId = pathStop.pathId;
            }
            else {
                draftMapPaths.push({
                    originID: prevPathStop.stopId,
                    origin: [prevPathStop.stopLatitude, prevPathStop.stopLongitude],
                    destinationID: pathStop.stopId,
                    destination: [pathStop.stopLatitude, pathStop.stopLongitude],
                    lineColor: undefined === pathStop.lineBackColor ?
                        defaultLineColor :
                        `rgba(${pathStop.lineBackColor.r},${pathStop.lineBackColor.g},${pathStop.lineBackColor.b},${pathStop.lineBackColor.a})`
                });
            }

            prevPathStop = pathStop;
        });

        this.setState({
            draftMapStops: draftMapStops,
            draftMapPaths: draftMapPaths
        });
    }

    clearError = () => {
        this.setState({
            showErrorModal: false
        });
    }

    // ----------------

    getAddOns() {
        const { commands, actions } = this.state;
        actions.isLoadingAddOns = true;
        commands.addOns.get(
            (a) => this.addOnsSuccessCallback(a),
            () => this.addOnsErrorCallback()
        );
    }

    addOnsSuccessCallback(result) {
        const { actions } = this.state;

        actions.isLoadingAddOns = false;

        this.setState({
            addOns: result,
            actions: actions
        });
    }

    addOnsErrorCallback() {
        const { actions } = this.state;

        actions.isLoadingAddOns = false;

        this.setState({
            actions: actions
        });
    }

    onExecuteAddOn(addOn, label, parameters = undefined) {
        const { commands, actions, render } = this.state;

        render.addOn = label;
        actions.isExecutingAddOn = true;
        commands.addOns.execute(
            addOn,
            label,
            parameters,
            (a) => this.operationSuccessCallback(a, "isExecutingAddOn", false),
            (a) => this.operationErrorCallback(a, "isExecutingAddOn")
        );

        this.setState({
            actions: actions,
            render: render
        });
    }

    operationSuccessCallback(messageReceived, updateAction, callback = undefined) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof callback) {
            callback();
        }
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }


        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    onHideForm() {
        const { form } = this.state;

        form.showNameForm = false;

        this.setState({
            form: form
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ----------------

    renderMaps() {
        const { loadingNetworkLines, loadingNetworkStops, loadingNetworkPaths, loadingNetworkTrips, loadingDraft } = this.state;

        if (loadingNetworkLines || loadingNetworkStops || loadingNetworkPaths || loadingNetworkTrips || loadingDraft) {
            return (<LoadingSpinner />);
        }

        const { networkMapStops, networkMapPaths, draftMapStops, draftMapPaths, networkStopsCount, networkPathsCount, networkLinesCount, networkTripsCount } = this.state;

        return (
            <Grid fluid className="dashboard margin-top-15">
                <Row>
                    <Col sm={6}>
                        <h4><Label>Rede Ativa</Label></h4>
                        <DashboardMap mapStops={networkMapStops}
                            mapPaths={networkMapPaths} />
                    </Col>
                    <Col sm={6}>
                        <h4><Label>Rascunho</Label></h4>
                        <DashboardMap mapStops={draftMapStops}
                            mapPaths={draftMapPaths} />
                    </Col>
                </Row>
                <Row className="margin-top-15">
                    <Col sm={3}>
                        <Label className="panel-labels panel-label-title">TOTAL PARAGENS</Label>
                        <Label className="panel-labels panel-label-data">
                            {networkStopsCount !== undefined ? <span>{networkStopsCount}</span> : <span>0</span>}
                        </Label>
                    </Col>
                    <Col sm={3}>
                        <Label className="panel-labels panel-label-title">TOTAL PERCURSOS</Label>
                        <Label className="panel-labels panel-label-data">
                            {networkPathsCount !== undefined ? <span>{networkPathsCount}</span> : <span>0</span>}
                        </Label>
                    </Col>
                    <Col sm={3}>
                        <Label className="panel-labels panel-label-title">TOTAL LINHAS</Label>
                        <Label className="panel-labels panel-label-data">
                            {networkLinesCount !== undefined ? <span>{networkLinesCount}</span> : <span>0</span>}
                        </Label>
                    </Col>
                    <Col sm={3}>
                        <Label className="panel-labels panel-label-title">TOTAL VIAGENS</Label>
                        <Label className="panel-labels panel-label-data">
                            {networkTripsCount !== undefined ? <span>{networkTripsCount}</span> : <span>0</span>}
                        </Label>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderOpenWebsiteAddOn() {
        const { addOns, actions } = this.state;

        if (!Array.isArray(addOns)) {
            return null;
        }

        const addOn = addOns.find(addOn => addOn.enabled && "UpdateWebsite" === addOn.name);
        if (undefined === addOn) {
            return null;
        }

        return (
            <Button onClick={() => this.onExecuteAddOn(addOn.name, addOn.label, undefined)} disabled={actions.isExecutingAddOn}>{addOn.label}</Button>
        )
    }

    render() {
        const { actions, render, message} = this.state;

        return (
            <div>
                <EditionSelector />

                <TitleRow title="Dashboard" showSeparator={true}>
                    <Col className="pull-right margin-right-negative-11" sm={16}>
                        {this.renderOpenWebsiteAddOn()}
                    </Col>
                </TitleRow>

                {this.renderMaps()}

                <HandleMessage title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    icon={this.state.icon}
                    style={this.state.alertStyle}
                    show={this.state.showErrorModal}
                    onHide={this.clearError} />

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleMessage
                    title={`A ${render.addOn}`}
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon={this.state.icon}
                    show={actions.isExecutingAddOn}
                    small
                    noButtons />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/dashboard/Dashboard.js